var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatRating = function SvgStatRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A6A5A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M17.25 18.074h-.728c-.767 0-1.495.297-2.032.834l-1.639 1.62a1.938 1.938 0 0 1-2.712 0L8.5 18.907a2.88 2.88 0 0 0-2.031-.834H5.75c-1.59 0-2.875-1.274-2.875-2.846V4.772c0-1.571 1.284-2.846 2.875-2.846h11.5c1.59 0 2.875 1.275 2.875 2.846v10.456c0 1.562-1.284 2.846-2.875 2.846Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A5A3",
    stroke: "#A6A5A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.768 14.337a1.02 1.02 0 0 1-.536 0c-1.246-.432-4.044-2.204-4.044-5.223a2.399 2.399 0 0 1 2.395-2.406c.786 0 1.476.374 1.917.959a2.387 2.387 0 0 1 1.917-.959 2.399 2.399 0 0 1 2.396 2.406c-.01 3.018-2.799 4.791-4.045 5.223Z",
    opacity: 0.4
  })));
};
export default SvgStatRating;